export default __webpack_public_path__ + "static/media/lemonade.8f15449f.jpg";